// import { pie as d3_pie } from 'd3-shape'
import { stack as d3_stack } from 'd3-shape'
import { extent as d3_extent, max as d3_max, min as d3_min } from 'd3-array'
import { convertRowsToData, transpose } from '../utils/dataUtils'
export default function SegmentedBarChartDataController(rows, config, hiddenItems) {
  let propperHeaders = ['id', 'value']
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], 1)

  data = [{ id: 'row', value: data.map(d => ({ ...d, parentId: 'row' })) }]
  if (hiddenItems)
    data.forEach(d => (d.value = d.value.filter(dd => hiddenItems.indexOf(dd.id) < 0)))
  let total = data.reduce(
    (sum, d) => sum + +d.value.reduce((subsum, dd) => subsum + +dd.value, 0),
    0
  )
  data = data.map(d => {
    return {
      ...d,
      value: d.value.map(dd => {
        return { ...dd, percentage: (100 * dd.value) / total }
      }),
    }
  })

  data.forEach(d => {
    d.totalPercentage = d.value.reduce((sum, dd) => sum + dd.percentage, 0)
    d.totalAbs = d.value.reduce((sum, dd) => sum + dd.value, 0)
  })
  if (config.dataSorting !== 'none') {
    data.sort((a, b) => {
      let diff = a.totalPercentage - b.totalPercentage
      return config.dataSorting === 'asc' ? diff : -diff
    })
  }
  // data = data.map(d => {
  //   let percent = Math.floor((100 * d.value) / total)
  //   if (percent < 1) percent = '<1'
  //   return { ...d, percent: percent }
  // })

  let extent = [
    d3_min(data, d => d3_min(d.value, dd => dd.percentage)),
    d3_max(data, d => d3_max(d.value, dd => dd.percentage)),
  ]
  if (extent[0] > 0) extent[0] = 0
  let extentSize = Math.abs(extent[1] - extent[0])
  let getSafeValue = v => {
    return config.minBarHeight
      ? Math.sign(v || 1) * Math.max((extentSize * config.minBarHeight) / 100, Math.abs(v))
      : +v
  }

  let keys = data.reduce((res, d) => {
    d.value.forEach(dd => res.push(dd.id))
    return res
  }, [])
  keys = keys.filter((value, index, self) => self.indexOf(value) === index)

  let objArray = data.map(layer => {
    let res = { id: layer.id }
    layer.value.forEach(dd => {
      res[dd.id] = {
        value: dd.value,
        percentage: dd.percentage,
        totalAbs: layer.totalAbs,
        totalPercentage: layer.totalPercentage,
      }
    })
    return res
  })
  let stack = d3_stack()
    .value((d, key) => getSafeValue(d[key].percentage))
    .keys(keys)

  let stacked = stack(objArray)
  let lastLayer = stacked[stacked.length - 1]
  let firstLayer = stacked[0]
  let result = stacked.map(layer => {
    return {
      id: layer.key,
      index: layer.index,
      value: layer.map((dd, i) => {
        return {
          id: dd.data.id,
          value: dd.data[layer.key].value,
          safeValue: getSafeValue(dd.data[layer.key].percentage),
          percent: dd.data[layer.key].percentage,
          y0: dd[0],
          y1: dd[1],
          layerIndex: layer.index,
          isLastLayer: keys.indexOf(layer.key) === keys.length - 1,
          isFirstLayer: keys.indexOf(layer.key) === 0,
          parentId: layer.key,
          layerTotal: dd.data[layer.key].totalPercentage,
          layerTotalAbs: dd.data[layer.key].totalAbs,
          barMax: lastLayer[i][1],
          barMin: firstLayer[i][0],
        }
      }),
    }
  })
  return result
}
